document.addEventListener('DOMContentLoaded',()=>{
  /* Header scroll — throttled with rAF */
  const hd=document.querySelector('.header');
  if(hd){let t=false;const f=()=>{hd.classList.toggle('scrolled',scrollY>10);t=false};window.addEventListener('scroll',()=>{if(!t){requestAnimationFrame(f);t=true}},{passive:true});f()}

  /* Mobile nav */
  const btn=document.querySelector('.header__hamburger'),nav=document.querySelector('.mobile-nav');
  if(btn&&nav){
    btn.addEventListener('click',()=>{const o=nav.classList.toggle('open');btn.setAttribute('aria-expanded',o);document.body.style.overflow=o?'hidden':''});
    nav.querySelectorAll('a').forEach(a=>a.addEventListener('click',()=>{nav.classList.remove('open');btn.setAttribute('aria-expanded','false');document.body.style.overflow=''}));
  }

  /* Service tabs — event delegation */
  document.querySelectorAll('[data-svc-tabs]').forEach(wrap=>{
    wrap.addEventListener('click',e=>{
      const t=e.target.closest('.svc-tab');if(!t)return;
      wrap.querySelectorAll('.svc-tab').forEach(x=>x.classList.remove('active'));
      wrap.querySelectorAll('.svc-panel').forEach(x=>x.classList.remove('active'));
      t.classList.add('active');const p=wrap.querySelector('#'+t.dataset.target);if(p)p.classList.add('active');
    });
  });

  /* FAQ accordion */
  document.querySelectorAll('.faq-q').forEach(q=>q.addEventListener('click',()=>q.parentElement.classList.toggle('open')));

  /* Scroll animations — IntersectionObserver */
  const obs=new IntersectionObserver(entries=>{entries.forEach(e=>{if(e.isIntersecting){const d=e.target.dataset.delay||0;setTimeout(()=>e.target.classList.add('fade-up'),d);obs.unobserve(e.target)}})},{threshold:.1});
  document.querySelectorAll('[data-animate]').forEach(el=>obs.observe(el));
});
